<template>

              <v-card class="text-left ma-3">
                <v-card-text>
                <v-img src="/Images/naked-age-sky-farm.jpg"/>
                <p><i>From <A @click="callLink(0)">The Naked Podcast - Episode 15</a>: America’s oldest nudist club and its revolutionary roots</i></p>

                 <A @click="callLink(0)">In this episode of Naked Age</a>, we journey to Sky Farm, the oldest continuously operating nudist club in America, and uncover its remarkable history. Founded in 1932 by a group of German immigrants led by Kurt Barthel and Bill Meyer, Sky Farm became a sanctuary for freedom and community. Through a rare archival interview and vivid storytelling, we trace its roots, the challenges it overcame, and the legacy it continues to uphold as a living testament to the nudist movement.

                  <v-btn text color="primary" @click="callLink(0)">{{links[0].title}}</v-btn>
                </v-card-text>
              </v-card>

</template>

<script>
export default {
    data: () => {
        return {
            links: [
                { title: "Naked Age - Sky Farm Rising",
                  name:  "Naked Age Podcast",
                  url: 'https://www.planetnude.co/p/naked-age-sky-farm-rising',
                },
            ],
        }
    },
    methods: {
        callLink(i) {
            this.$gtag.event('linkto', { event_label: this.links[i].title });
            window.open(this.links[i].url, '_blank')
        }
    }
}

</script>